import React from "react";

const SLUGS = [
  "simulatore-apertura-partita-iva",
  "calcolatore-convenienza-forfettario-ordinario",
  "gestore-forfettario",
  "registro-spese-deducibili",
];

const link = (slug, utmMedium) =>
  `https://casalisilvia.com/forfettari?utm_source=email&utm_medium=${utmMedium}&utm_campaign=${slug}`;

/** Proposta abbonamento Contabilità forfettari: mostrata solo per gli strumenti dei forfettari. */
export const ForfettariUpsellBox = ({ slug, utmMedium = "pagina_grazie" }) => {
  if (!SLUGS.includes(slug)) return null;
  const apertura = slug === "simulatore-apertura-partita-iva";

  return (
    <div
      className="bg-[#FAF6EE] border-2 border-[#C5A059] rounded-lg p-5 sm:p-6 text-left mb-8"
      data-testid="forfettari-upsell-box"
    >
      <p className="font-heading text-base md:text-lg text-[#0D1527] leading-snug mb-3">
        {apertura ? "Stai per aprire la partita IVA? Pensiamo a tutto noi" : "Preferisci che ci pensiamo noi?"}
      </p>
      <p className="text-[#4A5568] text-sm sm:text-base leading-relaxed mb-5">
        {apertura
          ? "Scrivici e ci occupiamo noi dell'apertura della partita IVA, con un preventivo a parte. Poi, con Contabilità forfettari a 43 € al mese IVA inclusa, prepariamo noi ogni anno dichiarazione dei redditi, imposta sostitutiva, contributi INPS e F24. Tutto online, senza appuntamenti."
          : "Con Contabilità forfettari, a 43 € al mese IVA inclusa, prepariamo noi dichiarazione dei redditi, imposta sostitutiva, contributi INPS e F24. Tutto online, senza appuntamenti."}
      </p>
      {apertura ? (
        <>
          <a
            href="mailto:assistenza@casalisilvia.com?subject=Apertura%20partita%20IVA"
            className="inline-flex items-center justify-center bg-[#C5A059] text-white hover:bg-[#B38E46] px-6 sm:px-8 py-3 rounded font-bold tracking-wide transition-all w-full sm:w-auto"
            data-testid="upsell-btn-scrivici"
          >
            SCRIVICI
          </a>
          <div className="mt-3">
            <a
              href={link(slug, utmMedium)}
              className="text-[#B38E46] underline text-sm"
              data-testid="upsell-link-forfettari"
            >
              Scopri Contabilità forfettari
            </a>
          </div>
        </>
      ) : (
        <a
          href={link(slug, utmMedium)}
          className="inline-flex items-center justify-center bg-[#C5A059] text-white hover:bg-[#B38E46] px-6 sm:px-8 py-3 rounded font-bold tracking-wide transition-all w-full sm:w-auto"
          data-testid="upsell-btn-scopri"
        >
          SCOPRI COME FUNZIONA
        </a>
      )}
    </div>
  );
};
